<app-page-title title="Setor"></app-page-title>
<div class="search-container" *ngIf="sectors.length > 0">
  <input
    class="search-input"
    placeholder="Buscar..."
    [(ngModel)]="searchValue"
    (input)="search($event.target.value)"
    autocomplete="off"
  />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" />
  </div>
</div>
<br />

<app-no-data *ngIf="sectors.length == 0" title="Sem dados" subtitle=" Nenhum setor cadastrado"></app-no-data>

<cdk-virtual-scroll-viewport itemSize="50" class="viewport">
  <div *ngFor="let sector of sectors" class="sector-container">
    <p class="description">
      {{ sector?.name }}
    </p>

    <div class="button-actions">
      <img
        class="btn-delete"
        src="../../../assets/icons/visibility_black_24dp.svg"
        matTooltip="Vizualizar"
        [routerLink]="['/setor/vizualizar/' + sector.id]"
      />
      <img
        class="btn-edit"
        src="../../../assets/icons/edit.svg"
        matTooltip="Editar"
        [routerLink]="['/setor/' + sector.id]"
      />
      <img
        class="btn-delete"
        src="../../../assets/icons/delete.svg"
        matTooltip="Remover"
        (click)="delete(sector.id, sector.name)"
      />
    </div>
  </div>
</cdk-virtual-scroll-viewport>

<!-- <div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>


    <ng-container matColumnDef="leader">
      <th mat-header-cell *matHeaderCellDef>Líder</th>
      <td mat-cell *matCellDef="let element">{{ element.leader.name }}</td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <img
          class="btn-edit"
          src="../../../assets/icons/visibility_black_24dp.svg"
          matTooltip="Vizualizar"
          [routerLink]="['/setor/vizualizar/' + element.id]"
        />
        <img
          class="btn-edit"
          src="../../../assets/icons/edit.svg"
          matTooltip="Editar"
          (click)="openEdit(element.id)"
        />
        <img
          class="btn-delete"
          src="../../../assets/icons/delete.svg"
          matTooltip="Remover"
          (click)="delete(element.id, element.name)"
        />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div> -->

<div class="example-button-container">
  <button mat-fab routerLink="/setor/add">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
